module.exports = __webpack_public_path__ + "img/ic_management.82485485.svg";